export default __webpack_public_path__ + "static/media/arrow.970ed074.svg";